import {MultiForm, useMultiFormContext} from "../../../../../Common/components/MultiForm";
import React from "react";
import {combineMultiFormData} from "../../../../../../util/Helpers";
import EmploymentDetails from "./EmploymentDetails";
import ComplianceDetails from "./ComplianceDetails";
import InvestmentProfile from "./InvestmentProfile";
import {Button} from "react-bootstrap";

export function InvestmentInformation(
    {
        dataKey,
        initialValues,
        updateKYC,
        isUpdating,
        isEditable,
    }
) {
    const {upsertValue} = useMultiFormContext();
    const {userGroup, userId} = initialValues

    const sections = [
        {title: "Employment Details", key: "employmentData", Component: EmploymentDetails},
        {title: "Investment Profile", key: "investmentData", Component: InvestmentProfile},
        {title: "Compliance & AML", key: "complianceData", Component: ComplianceDetails},
    ]

    const submit = (values) => {
        values = combineMultiFormData(values).data
        values.userGroup = userGroup
        values.userId = userId
        values.meta = initialValues
        updateKYC(values)
    }

    return <MultiForm onChange={(values) => upsertValue(dataKey, combineMultiFormData(values))}>
        {
            ({isDirty, isValid, values}) => (
                <>
                    {
                        sections.map(({key, title, Component}) => (
                            <span key={key}>
                                <Component
                                    dataKey={key}
                                    title={title}
                                    initialValues={initialValues}
                                    isEditable={isEditable}
                                />
                                <div className={"my-2"}/>
                            </span>
                        ))
                    }
                    {
                        (isDirty && isEditable) && <Button
                            onClick={() => submit(values)}
                            variant={"dark"}
                            className={`w-100 position-sticky bottom-0 zindex-1 mt-2`}
                            disabled={!isValid || isUpdating}
                        >
                            Apply Changes
                        </Button>
                    }
                </>
            )
        }
    </MultiForm>
}